import { render, staticRenderFns } from "./EditDraftDetails.vue?vue&type=template&id=1a35504b&scoped=true&"
import script from "./EditDraftDetails.vue?vue&type=script&lang=js&"
export * from "./EditDraftDetails.vue?vue&type=script&lang=js&"
import style0 from "./EditDraftDetails.vue?vue&type=style&index=0&id=1a35504b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1a35504b",
  null
  
)

export default component.exports